import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchEmployeeCategory, fetchEmployees } from "services/employee";
import { DROPDOWN_STALE_TIME, STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { replaceUnderscoresWithSpaces } from "utils";

const EmployeeAlreadyExists = ({ errors, control, setValue, getValues, watch }) => {


    const key = "employee_code_id";
    const selected = watch(key);
    const value = getValues()[key];
    const {
        data: datas,
        isLoading,
        refetch: refetchEmployees,
    } = useQuery(
        ["fetch-employees"],
        () => fetchEmployees(),
        {
            keepPreviousData: false,
            staleTime: STALE_TIME,
            select: (res) => {
                const response = res?.data?.data;
                const filteredEmployees = response?.filter((employee) => employee.employee_code_id === value);

                return filteredEmployees;
            },
            onError: (error) => {
                console.error("Error fetching employees:", error);
            },
        }
    );
    const { data, isLoadings, error } = useQuery(
        ["employee-category-dropdown"],
        fetchEmployeeCategory,
        {
            keepPreviousData: false,
            staleTime: DROPDOWN_STALE_TIME,
        }
    );

    if (isLoading) return <div>Loading...</div>;

    const matchingEmployee = datas.find(
        (employee) => employee.employee_code_id === value
    );

    const employeeCategoryObj = matchingEmployee?.employee_category_obj || [];

    const options = employeeCategoryObj.map((category) => {
        const matchingCategory = data?.data?.data?.find(nested => nested.id === category.employee_category_id);

        return {
            value: category.id,
            label: matchingCategory ? matchingCategory.employee_category : category.employee_category,
        };
    }) || [];

    const selectedOption = options.find(
        (option) => option.value === selected || option.value === value
    );

    return (
        <Controller
            name={key}
            control={control}
            readOnly
            rules={{
                required: `${replaceUnderscoresWithSpaces(
                    "Employee Category"
                )} is required`,
            }}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    isClearable
                    value={selectedOption || null}
                    placeholder={`Already ${replaceUnderscoresWithSpaces(
                        "Employee Category"
                    )}`}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    onChange={(selectedOption) => {
                        const value = selectedOption ? selectedOption.value : "";
                        refetchEmployees()
                        field.onChange(value);
                        setValue(key, value);
                    }}
                    className={`react-select-container ${errors[key] ? "is-invalid" : ""
                        }`}
                />
            )}
        />
    );
};

export default EmployeeAlreadyExists;
